var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._b({tag:"component",staticClass:"icon",class:[("icon-" + _vm.name)]},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }